module.exports = __webpack_public_path__ + "img/pp-59.edc79caf.jpg";